import React from 'react';

const AuthoringInfo = (props) => {
    return (
        (props.date || props.authorName) &&
        <div className="publishInfo publishInfo--padded text--blue">
            <p>
                {props.date && <span className="publishInfo__divider"> | </span>}
                {props.date && <span className="publishInfo__published">
                    <time dateTime={props.dateMicro}>{props.date}</time>
                </span>}
                <br />
                {props.authorName}{props.authorTitle && ','} {props.authorTitle}
            </p>
        </div>)
}

export default AuthoringInfo;